import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=a5d1db58&lang=scss&scoped=true"

import exportComponent from "/Users/qiuxiaofeng/Desktop/交接/assistant_eclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5d1db58"]])

export default __exports__